export * from './FolderCheckIcon';
export * from './FolderCheckIcon16Light';
export * from './FolderCheckIcon16Regular';
export * from './FolderCheckIcon16Solid';
export * from './FolderCheckIcon20Light';
export * from './FolderCheckIcon20Regular';
export * from './FolderCheckIcon20Solid';
export * from './FolderCheckIcon24Regular';
export * from './FolderCheckIcon24Solid';
export * from './FolderCheckIcon32Regular';
export * from './FolderCheckIcon64Regular';
